import React from 'react';

import { createRoot } from 'react-dom/client';
import ServiceView from './views/service';
import VipEventView from './views/vipEvent';
import ContactUsView from './views/contactUs';

const views = {
    'service': ServiceView,
    'vipevent': VipEventView,
    'contactus': ContactUsView
}

// Render your React component instead
const roots = document.getElementsByClassName('js-custom-form');
[...roots].forEach((root) => {
    const config = {
        submitUrl: root.dataset.submitUrl
    }
    const view = root.dataset.view;
    const viewComponent = views[view];
    const viewParamsStr = root.dataset.params;
    const viewParams = viewParamsStr ? JSON.parse(viewParamsStr) : null;

    createRoot(root).render(React.createElement(viewComponent, {...{config, ...viewParams}}) );
})

